import React from 'react';
import { makeStyles,useTheme } from '@material-ui/core/styles';
import {DialogActions,DialogContent,Button,useMediaQuery, Dialog, Avatar } from '@material-ui/core';
import Icon from '@mdi/react'
//import "./sliderDesign.css"
import { mdiEmail,mdiLinkedin,mdiGithubCircle,mdiClose } from '@mdi/js';

import LinkButton from './custom/LinkButton';
const useStyles = makeStyles(theme => ({
  dialogTitleRoot:{
    padding:'10px 0px',
    margin:'0',
  },
  dialogContentRoot:{
    width:'100%',
    minWidth:'240px',
    padding:'0px 0px',
  },
  dialogTitle:{
    padding:'3px',
    margin:'0px auto 15px',
    fontSize:40,
    textDecoration: 'underline',
    textDecorationColor: 'rgba(255,192,203,0.6)',
    width:'fit-content'
  },
  button: {
    margin:'10px 15px 30px ',
    padding:'0px 4px',
    textTransform:'none',
    textDecoration: 'underline',
    textDecorationColor: 'rgba(255,192,203,0.6)',
    background:'rgba(255,192,203,0.6)',
    color:'black',
    fontSize:20,
  },
  dialogRoot:{
      padding:'0px 20px',
      background: '#e7e7e7',
    },
}));

export default function ContactDialog(props) {
  const classes = useStyles();
  const theme = useTheme();
  const smDown = useMediaQuery(theme.breakpoints.down('sm'));

    return (
      <React.Fragment>
        <Dialog disableScrollLock={ true }
            open={props.isDialogOpen}
            maxWidth={'md'}
            onClose={props.handleCloseDialog}
            fullScreen={smDown}
            classes={{paper:classes.dialogRoot}}
            scroll="body"
            aria-labelledby="contact-dialog-title"
            aria-describedby="contact-dialog-description"
          >

          <DialogContent classes={{root:classes.dialogContentRoot}} >
            <div style={{textAlign:'center',marginBottom:'15px'}}>
          <Avatar alt="Amit Turner" src="https://amitturner.github.io/portfolio/images/me.png" style={{width:'55px',height:'55px',margin:'auto'}} />

          <span className={classes.dialogTitle}>
              Contact me
            </span>
            </div>
          <LinkButton text="Amitur91@gmail.com" icon={mdiEmail} link="mailto:amitur91@gmail.com"/>
            <br />
          <LinkButton text="Amit Turner" icon={mdiLinkedin} link="https://www.linkedin.com/in/amit-turner/"/>
            <br />
            <LinkButton text="AmitTurner" icon={mdiGithubCircle} link="https://github.com/AmitTurner"/>

          </DialogContent>

          <DialogActions>
            <Button onClick={props.handleCloseDialog} >
              <Icon path={mdiClose}
                    style={{marginBottom:'4px'}}
                    size={1}
                    color="rgba(0, 0, 0, 0.7)"
                    />
              Close
            </Button>
          </DialogActions>
        </Dialog>
      </React.Fragment>
    );
  }